import type * as React from 'react';
import { SIDETAB_POSITION, SideTab } from './SideTab';
import AgentSettingsIntegrationPanel from '../Panels/AgentSettingsIntegrationPanel';
import AgentSettingsVoIPPhonePanel from '../Panels/AgentSettingsVoIPPhonePanel';

interface IntegrationManagerProps {
  userAccessToken: string;
  userId: number;
  showIntegrationSetup: boolean;
  onHide: () => void;
  allowedServices: string[];
  agencyId?: number;
}

export const IntegrationManager: React.FC<IntegrationManagerProps> = ({
  userAccessToken,
  userId,
  showIntegrationSetup,
  onHide,
  allowedServices,
  agencyId,
}) => {
  return (
    <SideTab
      size="lg"
      position={SIDETAB_POSITION.RIGHT}
      title={''}
      show={showIntegrationSetup}
      onClose={(e) => onHide()}
    >
      <div className="alert alert-secondary p-2" style={{ fontSize: '10pt' }}>
        <i className="far fa-info-circle"></i> Integrations can also be managed from the{' '}
        <a href="https://www.medicareproapp.com/agent/settings/index/integration">Setting</a> page
      </div>
      {allowedServices.length > 0 && (
        <>
          <AgentSettingsVoIPPhonePanel
            userId={userId}
            userAccessToken={userAccessToken}
            allowedVoIPServices={allowedServices}
            renderedExternal={true}
            agencyId={agencyId}
          />

          <AgentSettingsIntegrationPanel
            userId={userId}
            userAccessToken={userAccessToken}
            allowedIntegrationServices={allowedServices}
            renderedExternal={true}
            agencyId={agencyId}
          />
        </>
      )}
    </SideTab>
  );
};
